<template>
  <v-container fluid>
    <v-row dense class="match-height">
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="body-2 v-card__subtitle">
            <v-icon left small class="mr-2">mdi-account-box</v-icon>Kundendaten
            <v-spacer></v-spacer>
            <v-btn
              v-if="hasWriteAccess"
              small
              depressed
              color="primary"
              @click="$emit('open-portal')"
            >
              <v-icon small left>mdi-open-in-new</v-icon>
              Verwalten in Abrechnungsportal
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row dense class="match-height">
              <v-col cols="12">
                <v-card outlined>
                  <v-list-item @click="copyToClipboard(customer.name || 'N/A')">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">{{
                        customer.name || "N/A"
                      }}</v-list-item-title>
                      <v-list-item-subtitle> Kunde </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-btn
                        depressed
                        icon
                        text
                        small
                        color="primary"
                        @click="copyToClipboard(customer.name || 'N/A')"
                      >
                        <v-icon small>mdi-content-copy</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="copyToClipboard(fullAddress)">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        <span v-if="customer.address.line1">
                          {{ customer.address.line1 }},
                        </span>
                        <span v-if="customer.address.line2">
                          {{ customer.address.line2 }}
                        </span>
                        <span
                          v-if="
                            customer.address.postal_code ||
                            customer.address.city
                          "
                        >
                          <span v-if="customer.address.postal_code">{{
                            customer.address.postal_code
                          }}</span
                          ><span
                            v-if="
                              customer.address.postal_code &&
                              customer.address.city
                            "
                            >&nbsp;</span
                          ><span v-if="customer.address.city">{{
                            customer.address.city
                          }}</span>
                        </span>
                        <span v-if="customer.address.country">
                          ({{ customer.address.country }})
                        </span>
                      </v-list-item-title>

                      <v-list-item-subtitle
                        >Rechnungsadresse</v-list-item-subtitle
                      >
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-btn
                        depressed
                        icon
                        text
                        small
                        color="primary"
                        @click="copyToClipboard(fullAddress)"
                      >
                        <v-icon small>mdi-content-copy</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item
                    @click="copyToClipboard(customer.email || 'N/A')"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        <span v-if="customer.email">
                          {{ customer.email }}
                        </span>
                      </v-list-item-title>

                      <v-list-item-subtitle
                        >E-Mail-Adresse</v-list-item-subtitle
                      >
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-btn
                        depressed
                        icon
                        text
                        small
                        color="primary"
                        @click="copyToClipboard(customer.email || 'N/A')"
                      >
                        <v-icon small>mdi-content-copy</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item @click="copyToClipboard(customer.id || 'N/A')">
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">{{
                        customer.id || "N/A"
                      }}</v-list-item-title>

                      <v-list-item-subtitle
                        >Kundenummer/-ID</v-list-item-subtitle
                      >
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-btn
                        depressed
                        icon
                        text
                        small
                        color="primary"
                        @click="copyToClipboard(customer.id || 'N/A')"
                      >
                        <v-icon small>mdi-content-copy</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="6">
        <v-card>
          <v-card-title class="body-2 v-card__subtitle">
            <v-icon left small class="mr-2">mdi-credit-card-outline</v-icon
            >Abrechnungsübersicht
          </v-card-title>
          <v-card-text>
            <v-row dense class="match-height">
              <v-col cols="12">
                <v-card outlined>
                  <!-- Current billing period info -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        Aktueller Abrechnungszeitraum
                      </v-list-item-title>
                      <v-list-item-subtitle v-if="currentBillingPeriod">
                        {{ timestampConverter(currentBillingPeriod.start) }}
                        -
                        {{ timestampConverter(currentBillingPeriod.end) }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-else> N/A </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider></v-divider>

                  <!-- License summary -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        Aktive Lizenzen
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ totalActiveLicenses }} von
                        {{ licenses.length }} Lizenzen aktiv
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider></v-divider>

                  <!-- Estimated costs -->
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title class="font-weight-medium">
                        Geschätzte Kosten (aktueller Zeitraum)
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <code class="font-weight-bold">{{
                          estimatedCurrentPeriodCost
                        }}</code>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { billingHelpersMixin } from "@/mixins/billingHelpers";

export default {
  name: "BillingTabOverview",
  mixins: [billingHelpersMixin],
  props: {
    customer: {
      type: Object,
      default: null,
    },
    licenses: {
      type: Array,
      default: () => [],
    },
    subscriptions: {
      type: Array,
      default: () => [],
    },
    hasWriteAccess: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    organizationBillingConfig() {
      return this.$store.getters["organization/billingConfig"];
    },
    customerId() {
      return this.organizationBillingConfig?.customerId;
    },
    fullAddress() {
      if (!this.customer?.address) return "N/A";

      const parts = [];

      if (this.customer.address.line1) {
        parts.push(this.customer.address.line1);
      }
      if (this.customer.address.line2) {
        parts.push(this.customer.address.line2);
      }

      const cityLine = [];
      if (this.customer.address.postal_code) {
        cityLine.push(this.customer.address.postal_code);
      }
      if (this.customer.address.city) {
        cityLine.push(this.customer.address.city);
      }
      if (cityLine.length > 0) {
        parts.push(cityLine.join(" "));
      }

      if (this.customer.address.country) {
        parts.push(`(${this.customer.address.country})`);
      }

      return parts.length > 0 ? parts.join(", ") : "N/A";
    },
    currentBillingPeriod() {
      if (!this.subscriptions || this.subscriptions.length === 0) {
        return null;
      }

      const activeSubscriptions = this.subscriptions.filter(
        (sub) => sub.status === "active",
      );

      if (activeSubscriptions.length === 0) return null;

      // Get the current period from the first active subscription
      const subscription = activeSubscriptions[0];

      // Only return the period if both start and end dates exist
      if (!subscription.currentPeriodStart || !subscription.currentPeriodEnd) {
        return null;
      }

      return {
        start: subscription.currentPeriodStart,
        end: subscription.currentPeriodEnd,
      };
    },
    totalActiveLicenses() {
      return this.licenses.filter(
        (license) =>
          license.status === "active" ||
          license.status === "pendingCancellation",
      ).length;
    },
    estimatedCurrentPeriodCost() {
      const activeLicenses = this.licenses.filter(
        (license) =>
          license.status === "active" ||
          license.status === "pendingCancellation",
      );

      const totalCents = activeLicenses.reduce((sum, license) => {
        return sum + (license.unitAmount || 0);
      }, 0);

      return this.getAmountFromCents(totalCents, "EUR");
    },
  },
  methods: {},
};
</script>
